import React, { Suspense } from 'react'; // Import Suspense
import { Outlet, Link } from 'react-router-dom'; // Outlet renders the child route (e.g., LoginPage)
// import Icon from '../components/common/Icon'; // Your common Icon component
import './AuthLayout.css'; // You will create this CSS file for styling

/**
 * AuthLayout provides a consistent layout wrapper for authentication pages
 * (Login, Register, Forgot Password, etc.).
 * @param {object} props
 * @param {React.ReactNode} [props.children] - Outlet will be used if routes are nested under AuthLayout.
 *                                           If not, pages are passed directly to element prop of Route.
 */
const AuthLayout = ({ children }) => { // Children prop might not be used if Outlet handles content
  const appName = import.meta.env.VITE_APP_NAME || 'Z';

  return (
    <div className="auth-layout-container"> {/* Full page wrapper, styled by AuthLayout.css */}
      <header className="auth-layout-header">
        <Link to="/" className="auth-layout-logo-link" aria-label={`Go to ${appName} homepage`}>
          {/* <Icon name="logo-Z" size={32} className="auth-layout-logo-icon" /> */}
          <span className="auth-layout-app-name">{appName}</span>
        </Link>
      </header>

      <main className="auth-layout-main-content">
        {/* FIX: Wrap Outlet with Suspense for lazy-loaded components */}
        <Suspense fallback={<div>Loading authentication page...</div>}> {/* You can use a Spinner here */}
          <Outlet />
        </Suspense>
        {/* If you weren't using nested routes with Outlet, and pages were passed as children:
            {children}
        */}
      </main>

      <footer className="auth-layout-footer">
        <nav className="auth-footer-links">
          {/* <Link to="/about">About</Link>
          <span className="footer-link-separator">•</span> */}
          <Link to="/terms">Terms of Service</Link>
          <span className="footer-link-separator">•</span>
          <Link to="/privacy">Privacy Policy</Link>
          {/* <span className="footer-link-separator">•</span>
          <Link to="/help">Help Center</Link> */}
        </nav>
        <p className="auth-footer-copyright">
          © {new Date().getFullYear()} {appName}. All rights reserved.
        </p>
      </footer>
    </div>
  );
};

export default AuthLayout;